import { IconProps } from '../types';

const IcPlaylist = (props: IconProps) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
    {...props}
  >
    <g clipPath='url(#clip0_14036_90273)'>
      <path
        d='M2.21256 9.99472C2.22041 9.92632 2.22041 9.85723 2.21256 9.78884C2.19432 9.7207 2.16772 9.65511 2.13338 9.59351C2.10619 9.52875 2.07257 9.46685 2.03308 9.40875C1.99649 9.35022 1.95208 9.29693 1.9011 9.25038C1.4893 8.84102 0.824212 8.84102 0.412415 9.25038C0.214121 9.44748 0.102107 9.71516 0.100952 9.99472C0.102998 10.1339 0.129822 10.2715 0.180138 10.4012C0.206599 10.4637 0.238405 10.5237 0.27516 10.5807C0.315314 10.6381 0.361307 10.6912 0.412415 10.7391C0.459068 10.7899 0.51232 10.8343 0.570785 10.871C0.62638 10.9116 0.686627 10.9452 0.750272 10.9713C0.814643 10.9984 0.881984 11.0179 0.950875 11.0294C1.01841 11.0446 1.08754 11.0516 1.15676 11.0505C1.22515 11.0584 1.29424 11.0584 1.36264 11.0505C1.42981 11.039 1.49541 11.0195 1.55796 10.9925C1.62332 10.9665 1.68535 10.9328 1.74273 10.8922C1.80119 10.8555 1.85445 10.8111 1.9011 10.7602C1.95198 10.7135 1.99639 10.6603 2.03308 10.6018C2.07366 10.5462 2.10734 10.486 2.13338 10.4223C2.16944 10.3522 2.19607 10.2777 2.21256 10.2006C2.22068 10.1322 2.22068 10.0631 2.21256 9.99472Z'
        fill={props?.fill ?? '#F53F3F'}
      />
      <path
        d='M2.21256 5.69003C2.22041 5.62163 2.22041 5.55255 2.21256 5.48415C2.19432 5.41602 2.16772 5.35042 2.13338 5.28882C2.10619 5.22406 2.07257 5.16216 2.03308 5.10406C1.99649 5.04553 1.95208 4.99224 1.9011 4.94569C1.4893 4.53633 0.824212 4.53633 0.412415 4.94569C0.214121 5.14279 0.102107 5.41047 0.100952 5.69003C0.102998 5.82917 0.129822 5.96678 0.180138 6.09652C0.206599 6.15897 0.238405 6.21902 0.27516 6.276C0.315314 6.33338 0.361307 6.38647 0.412415 6.43437C0.459068 6.48525 0.51232 6.52966 0.570785 6.56635C0.62638 6.60687 0.686627 6.64055 0.750272 6.66665C0.814643 6.69374 0.881984 6.71324 0.950875 6.72472C1.01841 6.73986 1.08754 6.74696 1.15676 6.74584C1.22515 6.75372 1.29424 6.75372 1.36264 6.74584C1.42981 6.73432 1.49541 6.71482 1.55796 6.68777C1.62332 6.66183 1.68535 6.62815 1.74273 6.58747C1.80119 6.55078 1.85445 6.50637 1.9011 6.45549C1.95198 6.40884 1.99639 6.35558 2.03308 6.29712C2.07366 6.24156 2.10734 6.18131 2.13338 6.11763C2.16944 6.04755 2.19607 5.97299 2.21256 5.89591C2.22068 5.82752 2.22068 5.75843 2.21256 5.69003Z'
        fill={props?.fill ?? '#F53F3F'}
      />
      <path
        d='M2.21256 14.2994C2.22041 14.231 2.22041 14.1619 2.21256 14.0935C2.19432 14.0254 2.16772 13.9598 2.13338 13.8982C2.10619 13.8334 2.07257 13.7715 2.03308 13.7134C1.99649 13.6549 1.95208 13.6016 1.9011 13.5551C1.4893 13.1457 0.824212 13.1457 0.412415 13.5551C0.214121 13.7522 0.102107 14.0198 0.100952 14.2994C0.102998 14.4385 0.129822 14.5762 0.180138 14.7059C0.206599 14.7683 0.238405 14.8284 0.27516 14.8854C0.315314 14.9428 0.361307 14.9958 0.412415 15.0437C0.459068 15.0946 0.51232 15.139 0.570785 15.1757C0.62638 15.2162 0.686627 15.2499 0.750272 15.276C0.814643 15.3031 0.881984 15.3226 0.950875 15.3341C1.01841 15.3492 1.08754 15.3563 1.15676 15.3552C1.22515 15.3631 1.29424 15.3631 1.36264 15.3552C1.42981 15.3437 1.49541 15.3242 1.55796 15.2971C1.62332 15.2712 1.68535 15.2375 1.74273 15.1968C1.80119 15.1602 1.85445 15.1157 1.9011 15.0649C1.95198 15.0182 1.99639 14.965 2.03308 14.9065C2.07366 14.8509 2.10734 14.7907 2.13338 14.727C2.16944 14.6569 2.19607 14.5824 2.21256 14.5053C2.22068 14.4369 2.22068 14.3678 2.21256 14.2994Z'
        fill={props?.fill ?? '#F53F3F'}
      />
      <path
        d='M14.7065 13.0399C14.765 13.5957 15.2451 13.9213 15.6356 13.6311L19.5842 10.6985C20.0041 10.3867 20.0041 9.59971 19.5842 9.28788L15.6356 6.3553C15.219 6.04586 14.7006 6.43685 14.7006 7.06061V12.9258C14.7006 12.9648 14.7026 13.0029 14.7065 13.0399Z'
        fill={props?.fill ?? '#F53F3F'}
      />
      <rect
        x='3.40002'
        y='9.00488'
        width='9.86165'
        height='1.99015'
        rx='0.995076'
        fill={props?.fill ?? '#F53F3F'}
      />
      <rect
        x='3.40002'
        y='4.7002'
        width='9.86165'
        height='1.99015'
        rx='0.995076'
        fill={props?.fill ?? '#F53F3F'}
      />
      <rect
        x='3.40002'
        y='13.3091'
        width='9.86165'
        height='1.99015'
        rx='0.995076'
        fill={props?.fill ?? '#F53F3F'}
      />
    </g>
    <defs>
      <clipPath id='clip0_14036_90273'>
        <rect width='20' height='20' fill='white' />
      </clipPath>
    </defs>
  </svg>
);

export default IcPlaylist;
